export default "__VITE_ASSET__BChaQWj8__"